var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("template", { slot: "header" }, [_vm._v("我的设置")]),
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, "label-width": "80px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "文档链接", prop: "helpUrl" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.helpUrl,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "helpUrl", $$v)
                  },
                  expression: "form.helpUrl"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "客服微信", prop: "pic" } },
            [
              _c(
                "el-upload",
                {
                  staticClass: "avatar-uploader",
                  attrs: {
                    action: _vm.uploadPath,
                    headers: _vm.uploadHeader,
                    "show-file-list": false,
                    "on-success": _vm.handleAvatarSuccess,
                    "before-upload": _vm.beforeAvatarUpload
                  }
                },
                [
                  _vm.form.wxImg
                    ? _c("img", {
                        staticClass: "avatar",
                        attrs: { src: _vm.form.wxImg }
                      })
                    : _c("i", {
                        staticClass: "el-icon-plus avatar-uploader-icon"
                      })
                ]
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "提审屏蔽", prop: "helpUrl" } },
            [
              _c("el-switch", {
                attrs: { "active-text": "开", "inactive-text": "关" },
                model: {
                  value: _vm.form.toExamine,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "toExamine", $$v)
                  },
                  expression: "form.toExamine"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onsubmit } },
                [_vm._v("保存")]
              ),
              _c("el-button", [_vm._v("取消")])
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }